import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
// ...existing imports...
import Communicator from '../components/Communicator/Communicator'
import IntakeInfo from '../components/IntakeTraige/IntakeInfo'
import ApplicationSummary from '../components/IntakeTraige/ApplicationSummary'
import DocumentSummary from '../components/IntakeTraige/DocumentSummary'
import AppChatBot from '../components/AppChatBot.jsx'
import AppetiteSummary from '../components/AppetiteSummary/AppetiteSummary'
import EscalationOverview from '../components/EscalationOverview/EscalationOverview'
import CompanyForm from '../components/Integrations/CompanyForm'
import PdfJsonViewerV2 from '../components/PDFViewer/PDFViewerNew'
import Container from '../components/AppetiteManagement/Container'
import Analytics from '../components/Analytics'
import CompanyAnalysisLayout from '../components/CompanyAnalysis/CompanyAnalysisLayout.jsx'

function V1Routes () {
  const selectedApplicationId = useSelector(
    state => state.intakeData.selectedAppId
  )
  return (
    <Routes>
      <Route
        path='app/details'
        element={
          <>
            <Communicator selectedApplicationId={selectedApplicationId} />
            <IntakeInfo />
            <ApplicationSummary />
            <DocumentSummary />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route
        path='app/intake/:id'
        element={
          <>
            <Communicator selectedApplicationId={selectedApplicationId} />
            <AppetiteSummary />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route
        path='app/escalate'
        element={
          <>
            <Communicator selectedApplicationId={selectedApplicationId} />
            <EscalationOverview />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route
        path='app/integrations'
        element={
          <>
            <Communicator selectedApplicationId={selectedApplicationId} />
            <CompanyForm />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route
        path='app/locations'
        element={
          <>
            <Communicator selectedApplicationId={selectedApplicationId} />
            <CompanyAnalysisLayout />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route
        path='app/analytics'
        element={
          <>
            <Communicator selectedApplicationId={selectedApplicationId} />
            <Analytics />
            <AppChatBot className='fixed top-4 right-4' />
          </>
        }
      />
      <Route path='app/pdfviewer' element={<PdfJsonViewerV2 />} />
      <Route
        path='app/appetite'
        element={
          <>
            <Container />
          </>
        }
      />
      <Route path='*' element={<div>Page not found</div>} />
    </Routes>
  )
}

export default V1Routes
